
<div class="success_popup">
  <div class="text-center">

      <div class="response_box bg_green">
        <img src="assets/images/thumb_up.svg" alt="">
    </div>


     <div class="d-flex align-items-end justify-content-center eh-mn-45 mt-30 mb-20">
      <p class="font-1_4  success_msg mb-0">
        {{ data.msg }}
        {{ data.Create_msg}}
      </p>
     </div>

    <!-- <p class="font-1_4 mb-30 success_msg">
  You Have Successfully Created Customer "ABC"
    </p> -->
      <button type="button" data-qa="Continue to Login button" class="bx-btn bx-btn-primary mx-10 btn_large mb-5"  (click)="donePopup()" > {{data.btnText | translate}} </button>
       <div *ngIf="data.type=='customer'">
         <span class="success_msg font-1_4">
          {{"OR"|translate}}
         </span>
        <a class="no-anchor cursor-pointer text-primary ml-5 font-1_4 text-button text-uppercase font-weight-600" (click)="donePopup('user-create')">{{'Continue to add user'|translate}}</a>

       </div>

  </div>
</div>

